import "./TitleContainer.css";
import { CgCloseO } from "react-icons/cg";
import { AiOutlineUnorderedList } from "react-icons/ai";

const TitleContainer = (props) => {
  return (
    <div className="event-details-title-container">
      <div></div>
      <div style={{ display: "flex", flexDirection: 'row', alignItems: "center", gap: "2px" }}>
        <AiOutlineUnorderedList
          cursor="pointer"
          color={"var(--textColor)"}
          size={19}
        />
        <h1 className="event-details-title"> {props.title}</h1>
      </div>
      {!props.isReception ? (
        <div style={{ marginRight: "10px" }}>
          <CgCloseO
            cursor="pointer"
            color={"var(--textColor"}
            size={23}
            onClick={() => props.close()}
          />
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};

export default TitleContainer;
